import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Moment from 'react-moment';
import ReactHtmlParser from 'react-html-parser';
import { userGroupUrlCheck,getUserTimeZone} from '../../../utils/userGroupUrlCheck';
import Toast from '../../commons/helpers/toast';
import ModalWindow from '../../commons/helpers/modalWindow';

import {URL_IMG} from '../../../configs/urlConfigs';
import * as labelConfigs from '../../../configs/labelConfigs'; 
import * as staticConfigs from '../../../configs/staticConfigs'; 
import { MSG_SERVER_DATA_FETCH_ERROR, MSG_NOT_FOUND,MSG_NOTIFICATION_READ_STATUS_ERROR } from '../../../configs/msgConfigs';
import * as notifications from '../../../configs/notificationConfigs'; 

import * as types from '../../../actions';
import { clearAction, menuActiveAction, serverTimeAction, assocUserActiveAction} from '../../../actions/commonActions'; 

import { logoutUserAction } from '../../../actions/authenticationActions';
import { notificationsFetchDropDownAction,notificationReadAction } from '../../../actions/fcmActions';  

import { getStorage, setStorage } from '../../../utils/browserStorage';
import Heartbeat from 'react-heartbeat'; 
import { converDateToLocal,checkBrowserAppleSafari } from '../../../utils/commonUtilities';
import { format } from 'date-fns';
import NetworkDetector from '../networkDetector';
import AssociateAddEditComponent from '../associatesAddEditComponent';  
import { eventPopupIdSetAction, shiftPopupIdSetAction } from '../../../actions/eventActions';
import { checkPermissions } from '../../../utils/permissions'; 

const isSafariBrowser = checkBrowserAppleSafari(); 

class HeaderComponent extends Component {   

    static propTypes = {
        location: PropTypes.object.isRequired,
    };

    constructor(props){
        super()
        this.interval = ''
        this.state = {
            notificationCount: 0,
            arrNotificationResults: [], 
            newNotificationsCount: 0,
            unreadCount: 0,
            notifyDropdownActive: 0,
            toastMessage: '',
            toastFlag: false,
            toastSuccess: true, 
            commonErrorMsg: '',
            activeUserNotifId: 0,
            activeRedirectURL: '',
            rand :Math.floor(Math.random()*staticConfigs.RANDOM_COLORS.length),
            datetime:'',
            timeOffset: '',
            dateObject: null,
            location: window.location,
            pageSubTitle:'', 
        }

        this.onLogout = this.onLogout.bind(this);

        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.modal= React.createRef(); 
    }

    onModalFormReset = () =>{       
        // this.setState({ activeUserId:0, activeUserProfileId:0, activeUserName:'' }); 
    }

    refreshPage = ()=>{
      window.location.reload();
    }

    readAndRedirect = (idValue,isRead,urlStr,menuActiveItem,refId,notifiAction) => {
        if(notifiAction===notifications.NOTIFI_ACT_TYPE_QUOTE || notifiAction===notifications.NOTIFI_ACT_TYPE_EVENT) {   
            this.props.eventPopupIdSetAction(refId); 
        }
        if(notifiAction===notifications.NOTIFI_ACT_TYPE_SHIFT) {   
            this.props.shiftPopupIdSetAction(refId); 
        }

        this.showNotificationsDropDown(); 
        this.props.menuActiveAction(menuActiveItem); 
        //console.log('menuActiveItem:'+menuActiveItem); 
        if(isRead) {
            this.props.history.push(urlStr);
            if(window.location.pathname === urlStr){
                this.refreshPage();
            }
        }
        else if(!isRead) { 
            this.setState({activeUserNotifId:idValue, activeRedirectURL:urlStr}, () => {
                let dataObj = {id:idValue}; 
                this.props.notificationReadAction(dataObj);
            }); 
        }
    }

    closeMyProfile = () => {
        this.modal.current.handleModelClose();
    }

    changePwd = (e,userGroup) => {
        this.remShowProfile(); 
        if(userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP){
            this.props.history.push(staticConfigs.ROUTE_CHANGE_PASSWORD);
        }else if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
            this.props.history.push(staticConfigs.ROUTE_AFFILIATE_CHANGE_PASSWORD);
        }else if(userGroup===staticConfigs.LOGIN_CLIENT_GROUP){
            this.props.history.push(staticConfigs.ROUTE_CLIENT_CHANGE_PASSWORD);
        }        
    } 

    showAssocUser = () => {
        this.remShowProfile(); 
        this.modal.current.handleOpenModal();
        let userGroupData = userGroupUrlCheck(window.location);
        let userGroup = ''; 
        let assocUserId = 0; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
            assocUserId = userGroupData.associate_id; 
        }

        // if(assocUserId) {
        //     this.props.assocUserActiveAction(assocUserId); 
        // }

        // if(userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP){
        //     this.props.history.push(staticConfigs.ROUTE_ASSOCIATES); 
        //     // affiliateId = userGroupData.profile_id;
        // }
        // else if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
        //     this.props.history.push(staticConfigs.ROUTE_AFFILIATE_ASSOCIATES); 
        //     // affiliateId = userGroupData.profile_id;
        // }else if(userGroup===staticConfigs.LOGIN_CLIENT_GROUP){
        //     this.props.history.push(staticConfigs.ROUTE_CLIENT_ASSOCIATES);
        // } 
    }

    remShowProfile = () => {
        document.getElementById("profile-dropdown").classList.remove('show');
        document.getElementById("dropdown-menu").classList.remove('show');  
        document.getElementById("profile-dropdown").classList.remove('active');
        document.getElementById("dropdown-menu").classList.remove('active');  
    }

    onShowProfile = () =>{        
        document.getElementById("profile-dropdown").classList.toggle('show');
        document.getElementById("dropdown-menu").classList.toggle('show'); 
        if(isSafariBrowser) document.getElementById('img-profile-logo').focus(); 
    }
    
    onShowSettings = () => {
        document.getElementById("right-menu-content").classList.add('active');
        document.getElementById("toggle-button").classList.remove('active');
        document.getElementById("side-menu").classList.remove('open');
        document.getElementById("push-bar").classList.remove('open');
    }

    onShowLeftSidebar = () => {
        document.getElementById("toggle-button").classList.toggle('active');
        document.getElementById("side-menu").classList.toggle('open');
        document.getElementById("push-bar").classList.toggle('open');
        document.getElementById("right-menu-content").classList.remove('active');
    }

    onTriggerClick = (e) =>{
        this.remShowProfile(); 
        this.props.history.push(e.target.pathname);
    }

    getSubTitle = (subTitleType) => {   
        if(subTitleType==='schedule-view') {      
            if(this.props.hasOwnProperty('scheduleHeadingSubTitle') && this.props.scheduleHeadingSubTitle && this.props.scheduleHeadingSubTitle.length > 1) {
                return (this.props.scheduleHeadingSubTitle); 
            }
            else {
                return ''; 
            }
        }
        else if(subTitleType==='rate-cards') {      
            if(this.props.hasOwnProperty('rateCardPageSubTitle') && this.props.rateCardPageSubTitle && this.props.rateCardPageSubTitle.length > 1) {
                return (this.props.rateCardPageSubTitle); 
            }
            else {
                return ''; 
            }
        }
    }
    
    getTitle = () => {
      let lblCrew = 'Staff';
      let userGroupData = userGroupUrlCheck(window.location);
      if(userGroupData!==undefined){
         if(userGroupData.staff_name){
            lblCrew = userGroupData.staff_name; 
         }
      }

      let scheduleViewType = ''; 
      let expiringCertificateTitle = labelConfigs.LBL_EXPIRING_CERTIFICATES; 
      let shiftTitle = labelConfigs.LBL_SHIFTS; 
      let feedbackTitle = labelConfigs.LBL_FEEDBACK; 
      let timeSheetShiftTitle = labelConfigs.LBL_TIMESHEET+' - '+labelConfigs.LBL_GROUP_BY+" "+labelConfigs.LBL_SHIFT; 
      let timeSheetCrewTitle = labelConfigs.LBL_TIMESHEET+' - '+labelConfigs.LBL_GROUP_BY+" "+lblCrew; 
      let crewListTitle = labelConfigs.LBL_CREW_LIST;
      if(this.props.hasOwnProperty('scheduleViewType') && (this.props.scheduleViewType)) {
            scheduleViewType = this.props.scheduleViewType; 
      }
      if(this.props.hasOwnProperty('expiringCertificateTitle') && (this.props.expiringCertificateTitle === 'expired')){
            expiringCertificateTitle = labelConfigs.LBL_EXPIRED_CERTIFICATES;
        }else{
            expiringCertificateTitle = labelConfigs.LBL_EXPIRING_CERTIFICATES;
        }
      if(this.props.hasOwnProperty('shiftTitle')){
            shiftTitle = this.props.shiftTitle;
            
        } 
      if(this.props.hasOwnProperty('feedbackTitle')){
            feedbackTitle = this.props.feedbackTitle;
            
        }
        if(this.props.hasOwnProperty('crewListTitle')){
            crewListTitle = this.props.crewListTitle?this.props.crewListTitle:crewListTitle;
            
        }
        if(this.props.hasOwnProperty('timesheetDateTitle')){
            console.log(this.props.timesheetDateTitle);
            timeSheetShiftTitle = timeSheetShiftTitle + " " + this.props.timesheetDateTitle;
            timeSheetCrewTitle = timeSheetCrewTitle + " " + this.props.timesheetDateTitle;
            
        } 

      if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_AFFILIATE_PROFILE+'/')) >=0) {
          let tmpArr = this.props.location.pathname.split('/');
          if(parseInt(tmpArr[3],10)) return('Edit '+labelConfigs.LBL_AFFILIATE);
          else return('Add '+labelConfigs.LBL_AFFILIATE);
      }
      else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_AFFILIATE_CLIENT_PROFILE+'/')) >=0) {
        let tmpArr = this.props.location.pathname.split('/');
        if(parseInt(tmpArr[3],10)) return('Edit '+labelConfigs.LBL_CLIENT);
        else return('Add '+labelConfigs.LBL_CLIENT);
      }else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_CLIENT_PROFILE+'/')) >=0) {
        return(labelConfigs.LBL_CLIENT+' Profile');
      }else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_AFFILIATE_CREW_PROFILE+'/')) >=0) {
        let tmpArr = this.props.location.pathname.split('/');
        if(parseInt(tmpArr[3],10)) return(labelConfigs.LBL_CREW_EDIT);  
        else return(labelConfigs.LBL_CREW_ADD);
      }else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_AFFILIATE_SCHEDULE_SHIFT+'/')) >=0) {        
        return(labelConfigs.LBL_SCHEDULE_SHIFT+' '+labelConfigs.LBL_SHIFTS);
      } 
      else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_AFFILIATE_QUOTES+'/')) >=0) {
        return(labelConfigs.LBL_QUOTES);
      } 
      else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_AFFILIATE_EVENTS+'/')) >=0) {
        return(labelConfigs.LBL_EVENTS);
      }
      else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_CLIENT_QUOTES+'/')) >=0) {
        return(labelConfigs.LBL_QUOTES);
      }
      else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_CLIENT_EVENTS+'/')) >=0) {
        return(labelConfigs.LBL_EVENTS);
      } 
      else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_AFFILIATE_SHIFT+'/')) >=0) {
        return(shiftTitle);
      } 
      else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_AFFILIATE_FEEDBACK+'/')) >=0) {
        return(feedbackTitle);
      }
      else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_AFFILIATE_TIMESHEET_CREW_BASED)) >=0){
        return(timeSheetCrewTitle);
      }
      else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_AFFILIATE_TIMESHEET+'/')) >=0){
        return(timeSheetShiftTitle);
      }
      else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_CLIENT_TIMESHEET+'/')) >=0){
        return(timeSheetShiftTitle);
      }else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_CLIENT_TIMESHEET_CREW_BASED+'/')) >=0){
        return(timeSheetCrewTitle);
      }else if(this.props.location.pathname.indexOf((staticConfigs.ROUTE_AFFILIATE_CREW+'/')) >=0){
        return(crewListTitle);
      }
      
      else {
        switch(this.props.location.pathname){
            // *************** SUPER ADMIN PAGES - START ******************************

                case staticConfigs.ROUTE_NOTIFICATIONS: return labelConfigs.LBL_NOTIFICATIONS;
                
                // *************** SUPER ADMIN - LEFT MENU - START ******************
                case staticConfigs.ROUTE_DASHBOARD:return labelConfigs.LBL_DASHBOARD;
                case staticConfigs.ROUTE_QUOTES:return labelConfigs.LBL_QUOTES;
                case staticConfigs.ROUTE_EVENTS:return labelConfigs.LBL_EVENTS;
                case staticConfigs.ROUTE_AFFILIATE_PROFILE:return labelConfigs.LBL_ADD_AFFILIATE;        
                case staticConfigs.ROUTE_AFFILIATE_PROFILE+'/' :return 'Edit '+labelConfigs.LBL_AFFILIATE;
                case staticConfigs.ROUTE_CLIENTS:return labelConfigs.LBL_CLIENTS;
                case staticConfigs.ROUTE_LOGS:return labelConfigs.LBL_LOGS;
                case staticConfigs.ROUTE_FEEDBACK:return feedbackTitle;
                case staticConfigs.ROUTE_LOGIN_AS:return labelConfigs.LBL_LOGIN_AS;
                case staticConfigs.ROUTE_ASSOCIATES:return labelConfigs.LBL_ASSOCIATE_USERS;
                case staticConfigs.ROUTE_SA_SETTINGS:return labelConfigs.LBL_SETTINGS;

                // *************** SUPER ADMIN - LEFT MENU - END *********************
                
                // *************** SUPER ADMIN - SETTINGS - START ********************
                case staticConfigs.ROUTE_SKILLS:return labelConfigs.LBL_SETTINGS + ' - '+labelConfigs.LBL_SKILLS;
                case staticConfigs.ROUTE_SECTORS:return labelConfigs.LBL_SETTINGS + ' - '+labelConfigs.LBL_SECTORS;
                case staticConfigs.ROUTE_SUB_SECTORS:return labelConfigs.LBL_SETTINGS + ' - '+labelConfigs.LBL_SUB_SECTORS;
                case staticConfigs.ROUTE_OTHER_EXPENSES:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_OTHER_EXPENSES;
                case staticConfigs.ROUTE_CLIENT_CATEGORY:return labelConfigs.LBL_SETTINGS + ' - '+labelConfigs.LBL_CLIENT_CATEGORIES; 
                case staticConfigs.ROUTE_CLIENT_DOCS:return labelConfigs.LBL_SETTINGS + ' - '+labelConfigs.LBL_CLIENT+" "+labelConfigs.LBL_DOCUMENTS;  
                case staticConfigs.ROUTE_CREW_DOCS:return labelConfigs.LBL_SETTINGS + ' - '+labelConfigs.LBL_CREW+" "+labelConfigs.LBL_DOCUMENTS;  
                case staticConfigs.ROUTE_DYNAMIC_FIELDS_CREW:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_DYNAMIC+' '+labelConfigs.LBL_FIELDS+" for "+labelConfigs.LBL_CREW;
                case staticConfigs.ROUTE_DYNAMIC_FIELDS_CLIENTS:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_DYNAMIC+' '+labelConfigs.LBL_FIELDS+" for "+labelConfigs.LBL_CLIENTS;
                case staticConfigs.ROUTE_DYNAMIC_FIELDS_AFFILIATES:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_DYNAMIC+" "+labelConfigs.LBL_FIELDS+" for "+labelConfigs.LBL_AFFILIATES;
                case staticConfigs.ROUTE_OMNU_POINTS:return labelConfigs.LBL_SETTINGS + ' - ' +labelConfigs.LBL_PP_POINTS;
                case staticConfigs.ROUTE_ROLES_PERMISSIONS:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_ROLES+ ' & ' + labelConfigs.LBL_PERMISSIONS;
                case staticConfigs.ROUTE_CHANGE_PASSWORD:return labelConfigs.LBL_CHANGE_PASSWORD; // labelConfigs.LBL_SETTINGS + ' - '
                case staticConfigs.ROUTE_OMNU_POINTS_SETTINGS:return labelConfigs.LBL_SETTINGS + ' - '+labelConfigs.LBL_OMNU_POINTS_AGAINST_PP_TITLE; 
                case staticConfigs.ROUTE_CANCEL_REASONS:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_EVENT_CANCEL_REASONS;
                case staticConfigs.ROUTE_TERMS_AND_CONDITIONS:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_TERMS_AND_CONDITIONS; 
                case staticConfigs.ROUTE_TERMS_ACCEPT:return labelConfigs.LBL_TERMS_AND_CONDITIONS;
                case staticConfigs.ROUTE_BASIC_CONFIG:return labelConfigs.LBL_SETTINGS + ' - ' +labelConfigs.LBL_BASIC_CONFIGS;
                case staticConfigs.ROUTE_TRAVEL_MODULE_FIELDS_AFFILIATES: return labelConfigs.LBL_SETTINGS + ' - ' +labelConfigs.LBL_TRAVEL_MODULE_FIELDS_AFFILIATES
                
                // *************** SUPER ADMIN - SETTINGS - END ********************* 
    
            // *************** SUPER ADMIN PAGES - END ****************************************
    
    
            // *************** AFFILIATES PAGES - START **************************************** 
                case staticConfigs.ROUTE_AFFILIATES:return labelConfigs.LBL_AFFILIATES;  
                case staticConfigs.ROUTE_AFFILIATE_NOTIFICATIONS: return labelConfigs.LBL_NOTIFICATIONS;
                // *************** AFFILIATES - LEFT MENU  - START *********************          
                case staticConfigs.ROUTE_AFFILIATE_DASHBOARD:return labelConfigs.LBL_DASHBOARD;
                case staticConfigs.ROUTE_AFFILIATE_CLIENTS:return labelConfigs.LBL_CLIENTS;
                case staticConfigs.ROUTE_AFFILIATE_QUOTES:return labelConfigs.LBL_QUOTES;
                case staticConfigs.ROUTE_AFFILIATE_EVENTS:return labelConfigs.LBL_EVENTS;
                case staticConfigs.ROUTE_AFFILIATE_SHIFT:return shiftTitle;
                case staticConfigs.ROUTE_AFFILIATE_SCHEDULE_SHIFT:return labelConfigs.LBL_SCHEDULE_SHIFT+' '+labelConfigs.LBL_SHIFTS;
                case staticConfigs.ROUTE_AFFILIATE_TIMESHEET:return timeSheetShiftTitle;
                case staticConfigs.ROUTE_AFFILIATE_LOGS:return labelConfigs.LBL_LOGS;
                case staticConfigs.ROUTE_AFFILIATE_CLIENT_PROFILE+"/":
                    return labelConfigs.LBL_ADD_CLIENT;
                case staticConfigs.ROUTE_AFFILIATE_CLIENT_PROFILE:
                    return labelConfigs.LBL_ADD_CLIENT;
                case staticConfigs.ROUTE_AFFILIATE_CREW: 
                    return crewListTitle;
                case staticConfigs.ROUTE_AFFILIATE_CREW_PROFILE+"/":
                    return 'Add '+labelConfigs.LBL_CREW;
                case staticConfigs.ROUTE_AFFILIATE_CREW_PROFILE:
                    return 'Add '+labelConfigs.LBL_CREW;
                case staticConfigs.ROUTE_AFFILIATE_ASSOCIATES: 
                    return labelConfigs.LBL_ASSOCIATE_USERS; 
                case staticConfigs.ROUTE_AFFILIATE_SCHEDULE_VIEW: return labelConfigs.LBL_SCHEDULE_SHIFT+scheduleViewType;
                case staticConfigs.ROUTE_AFFILIATE_FEEDBACK: return feedbackTitle;
                case staticConfigs.ROUTE_AFFILIATE_UNAVILABILITY: return labelConfigs.LBL_CREW_UNAVAILABILITY;
                case staticConfigs.ROUTE_AFFILIATE_CSV_TEMPLATES: return (labelConfigs.LBL_SETTINGS + ' - ' +labelConfigs.LBL_CSV_DOWNLOAD_HEADING);
                case staticConfigs.ROUTE_PROFILE: return (labelConfigs.LBL_SETTINGS + ' - ' +labelConfigs.LBL_COMPANY_PROFILE);
                case staticConfigs.ROUTE_AFFILIATE_TERMS_ACCEPT: return labelConfigs.LBL_TERMS_AND_CONDITIONS;
                case staticConfigs.ROUTE_AFFILIATE_REPORTS: return labelConfigs.LBL_REPORTS;
                case staticConfigs.ROUTE_CREW_AVAILABILITY_REPORTS: return labelConfigs.LBL_CREW_AVAILABILITY;
                case staticConfigs.ROUTE_CREW_AVAIL_SUMMARY_REPORT: return labelConfigs.LBL_CREW_AVAIL_SUMMARY_REPORT; 
                case staticConfigs.ROUTE_VEHICLE_INFO:return labelConfigs.LBL_SETTINGS + ' - ' +labelConfigs.LBL_VEHICLE_INFO; 
                // *************** AFFILIATES - LEFT MENU  - END ***********************
    
                // *************** AFFILIATES - SETTINGS - START ********************* 
                case staticConfigs.ROUTE_AFFILIATE_PROFILE_MANAGE:return (labelConfigs.LBL_SETTINGS + ' - ' +labelConfigs.LBL_COMPANY_PROFILE);
                case staticConfigs.ROUTE_AFFILIATE_SKILLS:return labelConfigs.LBL_SETTINGS + ' - '+labelConfigs.LBL_SKILLS;
                case staticConfigs.ROUTE_AFFILIATE_XP_PAY_RATE:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_APPAYRATE;
                case staticConfigs.ROUTE_AFFILIATE_CLIENT_DOCS:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_CLIENT+' '+labelConfigs.LBL_DOCUMENTS;
                case staticConfigs.ROUTE_AFFILIATE_CREW_DOCS:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_CREW+' '+labelConfigs.LBL_DOCUMENTS;
                case staticConfigs.ROUTE_AFFILIATE_DYNAMIC_FIELDS_CREW:return labelConfigs.LBL_SETTINGS + ' - '+labelConfigs.LBL_DYNAMIC+' '+labelConfigs.LBL_FIELDS+" for "+lblCrew; 
                case staticConfigs.ROUTE_AFFILIATE_DYNAMIC_FIELDS_CLIENTS:return labelConfigs.LBL_SETTINGS + ' - '+labelConfigs.LBL_DYNAMIC+' '+labelConfigs.LBL_FIELDS+" for "+labelConfigs.LBL_CLIENTS;       
                case staticConfigs.ROUTE_AFFILIATE_MASTER_RATE_CARD:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_MASTER_RATE_CARD; 
                case staticConfigs.ROUTE_AFFILIATE_SKILL_RATE_CARDS:return labelConfigs.LBL_RATE_CARDS; 
                case staticConfigs.ROUTE_AFFILIATE_EVENT_LOCATIONS:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_EVENT_LOCATIONS;
                case staticConfigs.ROUTE_AFFILIATE_KEY_LOCATIONS:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_KEY_LOCATIONS;
                case staticConfigs.ROUTE_AFFILIATE_DEPARTMENTS:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_DEPARTMENTS;
                case staticConfigs.ROUTE_AFFILIATE_RATECARDS:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_RATE_CARDS;
                case staticConfigs.ROUTE_AFFILIATE_OTHER_EXPENSES:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_OTHER_EXPENSES;
                case staticConfigs.ROUTE_AFFILIATE_ROLES_PERMISSIONS:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_ROLES+ ' & ' + labelConfigs.LBL_PERMISSIONS;
                case staticConfigs.ROUTE_AFFILIATE_INVITE_FRIEND:return labelConfigs.LBL_STAFF_LIST + ' - ' + labelConfigs.LBL_INVITE_A_FRIEND; 
                case staticConfigs.ROUTE_AFFILIATE_CHANGE_PASSWORD:return labelConfigs.LBL_CHANGE_PASSWORD; // labelConfigs.LBL_SETTINGS + ' - '+
                case staticConfigs.ROUTE_AFFILIATE_PAY_LEVELS:return labelConfigs.LBL_SETTINGS + ' - '+labelConfigs.LBL_PAY_LEVELS; 
                case staticConfigs.ROUTE_AFFILIATE_CERTIFICATES:return expiringCertificateTitle; 
                case staticConfigs.ROUTE_AFFILIATE_CLIENT_CATEGORY:return labelConfigs.LBL_SETTINGS + ' - '+labelConfigs.LBL_CLIENT_CATEGORIES; 
                case staticConfigs.ROUTE_AFFILIATE_VEHICLE_INFO:return labelConfigs.LBL_SETTINGS + ' - ' +labelConfigs.LBL_VEHICLE_INFO; 
                case staticConfigs.ROUTE_AFFILIATE_VEHICLE_DETAILS:return labelConfigs.LBL_SETTINGS + ' - ' +labelConfigs.LBL_VEHICLE_DETAILS;
                case staticConfigs.ROUTE_AFFILIATE_CANCEL_REASONS:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_EVENT_CANCEL_REASONS;
                case staticConfigs.ROUTE_AFFILIATE_BASIC_CONFIG:return labelConfigs.LBL_SETTINGS + ' - ' + labelConfigs.LBL_BASIC_CONFIGS;
                case staticConfigs.ROUTE_AFFILIATE_SETTINGS:return labelConfigs.LBL_SETTINGS;
                
                
                // *************** AFFILIATES - SETTINGS - END *********************** 
            // *************** AFFILIATES PAGES - END ******************************************  

            // *************** CLIENT LOGIN PAGES - START ******************************
                case staticConfigs.ROUTE_CLIENT_DASHBOARD: return labelConfigs.LBL_DASHBOARD;
                case staticConfigs.ROUTE_CLIENT_PROFILE_MANAGE: return labelConfigs.LBL_COMPANY_PROFILE;
                case staticConfigs.ROUTE_CLIENT_NOTIFICATIONS: return labelConfigs.LBL_NOTIFICATIONS; 
                case staticConfigs.ROUTE_CLIENT_QUOTES: return labelConfigs.LBL_QUOTES;
                case staticConfigs.ROUTE_CLIENT_EVENTS: return labelConfigs.LBL_EVENTS;
                case staticConfigs.ROUTE_CLIENT_TIMESHEET: return timeSheetShiftTitle;
                case staticConfigs.ROUTE_CLIENT_TIMESHEET_CREW_BASED: return timeSheetCrewTitle;
                case staticConfigs.ROUTE_CLIENT_FEEDBACK: return feedbackTitle;
                case staticConfigs.ROUTE_CLIENT_ASSOCIATES: return labelConfigs.LBL_ASSOCIATE_USERS; 
                case staticConfigs.ROUTE_CLIENT_CHANGE_PASSWORD : return labelConfigs.LBL_CHANGE_PASSWORD;  
                case staticConfigs.ROUTE_CLIENT_LOGS:return labelConfigs.LBL_LOGS;         
                case staticConfigs.ROUTE_CLIENT_TERMS_ACCEPT: return labelConfigs.LBL_TERMS_AND_CONDITIONS;     
                 case staticConfigs.ROUTE_AFFILIATE_SCHEDULE_SHIFT_CALENDAR: return labelConfigs.LBL_SCHEDULE_CALENDAR;
            // *************** CLIENT LOGIN PAGES - START ******************************
            
                default:
                    return labelConfigs.LBL_APP_NAME; 
            }          
        }
    }

    onLogout = () =>{
        let userGroupData = userGroupUrlCheck(window.location);
        let username      = '';
        let unid          = '';
        let fcmToken = getStorage('fcmNotificationToken');
        if(userGroupData!==undefined){
            username      = userGroupData.username;
            unid          = userGroupData.unid;
        }
       
        this.props.logoutUserAction({username: username,unid:unid,fcm_token:fcmToken,device_type:1});
    }

    setNofificationCount = (fromFunc) => {
        let userGroupData = userGroupUrlCheck(this.props.location);
        let notificationCount = 0; 
        if(userGroupData!==undefined){
            notificationCount  = userGroupData.notification_count;
            if(this.state.notificationCount!==userGroupData.notification_count) {
                this.setState({notificationCount:notificationCount}); 
            }
        }
    }

    showNotificationsDropDown = () => {
        let dropdown     = document.getElementById('dropdown-test');
        let dropdownMenu = document.getElementById('dropdown-menu-test');
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');    
        if(this.state.notifyDropdownActive===0) {
            let dataObj = {pageSize:5}; 
            this.props.notificationsFetchDropDownAction(dataObj); 
            this.setState({notifyDropdownActive:1}); 
            document.getElementById('img_bell').focus(); 
        }
        else if(this.state.notifyDropdownActive) {
            this.setState({notifyDropdownActive:0}); 
        }        
    } 

    handleClickOutside(event) { // to hide notification on outside click
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            let dropdown     = document.getElementById('dropdown-test');
            let dropdownMenu = document.getElementById('dropdown-menu-test');
            dropdown.classList.remove('show');
            dropdownMenu.classList.remove('show'); 
            this.setState({notifyDropdownActive:0});
        }
    }

    goToNotifications = () => {
        if(this.state.notifyDropdownActive > 0) {
            this.showNotificationsDropDown(); 
        }
        const { location } = this.props;
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = '';
        let notificationsRoute = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
            if(userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP){
                notificationsRoute = staticConfigs.ROUTE_NOTIFICATIONS;
            }else if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
                notificationsRoute = staticConfigs.ROUTE_AFFILIATE_NOTIFICATIONS;
            }else if(userGroup===staticConfigs.LOGIN_CLIENT_GROUP){
                notificationsRoute = staticConfigs.ROUTE_CLIENT_NOTIFICATIONS;
            }
            this.props.history.push(notificationsRoute);
        }
     }
     setDateTime(raw_object){
        let {dateObject} = raw_object.state;
        if(dateObject){
            dateObject.setSeconds( dateObject.getSeconds() + 1 );
            let strDatetime = format(dateObject,"cccc dd, MMM HH:mm:ss")
            raw_object.setState({dateObject:dateObject,datetime:strDatetime});
        }
     }

    componentDidMount() {
        this.setNofificationCount('componentDidMount');
        // Timer in dashboard -- 2020-07-30T09:30:00Z
        //const { location} = this.props;
        let timeZone =  getUserTimeZone(this.props.location);
        let abbreviation = timeZone.region;  
        //let offset = timeZone.offset;
        let timeOffset = abbreviation;
        this.props.serverTimeAction();
        this.setState({timeOffset:timeOffset});
        var self = this; 
        // setInterval(function() {
        //   self.setDateTime(self)
        // }, 1000);

        document.addEventListener('mousedown', this.handleClickOutside); // to hide notification on outside click

    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside); // to hide notification on outside click
    }

    componentDidUpdate(prevProps){ 
        const {activity,status,notificationsFetchDropDownStatus,notificationsFetchDropDownActivity,notificationsFetchDropDownData, notificationReadStatus, notificationReadActivity, notificationReadErrorData, serverTimeList,scheduleHeadingSubTitle,rateCardPageSubTitle,location} = this.props;   

        this.setNofificationCount('componentDidUpdate');  

        // let subTitle = ''; 
        // if(location.pathname.includes('schedule-view')) {
        //     subTitle = this.getSubTitle('schedule-view');
        //     this.setState({pageSubTitle:subTitle}); 
        // }
        // else if(location.pathname.includes('skill-rate-cards')) {
        //     subTitle = this.getSubTitle('rate-cards');
        //     this.setState({pageSubTitle:subTitle}); 
        // }

        if(location.pathname.includes('schedule-view') && scheduleHeadingSubTitle!==prevProps.scheduleHeadingSubTitle) {
            this.setState({pageSubTitle:scheduleHeadingSubTitle}); 
        }

        if(location.pathname.includes('skill-rate-cards') && rateCardPageSubTitle!==prevProps.rateCardPageSubTitle) {
            this.setState({pageSubTitle:' - '+rateCardPageSubTitle}); 
        }

        if(!location.pathname.includes('skill-rate-cards') && !location.pathname.includes('skill-rate-cards') && this.state.pageSubTitle!=='') {
            this.setState({pageSubTitle:''}); 
        }

        if (activity !== prevProps.activity) {
            if(activity===types.LOGOUT_USER_SUCCESS){
                
                let userGroupData = userGroupUrlCheck(this.props.location);
                let userGroup  = '';
            
                if(userGroupData!==undefined){
                    userGroup  = userGroupData.user_group;
                }

                let loginRoute = '';
                let dashboardRoute = '';
                if(userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP){
                    loginRoute = staticConfigs.LOGIN_ROUTE_SUPER_ADMIN;
                    dashboardRoute = staticConfigs.ROUTE_DASHBOARD;
                }else if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
                    loginRoute = staticConfigs.LOGIN_ROUTE_AFFILIATE;
                    dashboardRoute = staticConfigs.ROUTE_AFFILIATE_DASHBOARD;
                }else if(userGroup===staticConfigs.LOGIN_CLIENT_GROUP){
                    loginRoute = staticConfigs.LOGIN_ROUTE_CLIENT;
                    dashboardRoute = staticConfigs.ROUTE_CLIENT_DASHBOARD;
                }

                if(status){

                    if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
                        document.body.classList.remove('body-affiliate'); 
                    }

                    if(this.props.location.pathname.includes(staticConfigs.LOGIN_ROUTE_SUPER_ADMIN)){
                        localStorage.removeItem("super");
                    }else if(this.props.location.pathname.includes(staticConfigs.LOGIN_ROUTE_AFFILIATE)){
                        localStorage.removeItem("affiliate");
                    }else if(this.props.location.pathname.includes(staticConfigs.LOGIN_ROUTE_CLIENT)){
                        localStorage.removeItem("client");
                    }else{
                        localStorage.clear();
                    }                
                    this.props.history.push(loginRoute);
                }else{
                    this.props.history.push(dashboardRoute)
                }
       
            }
            this.props.clearAction();
        }
        let {dateObject} = this.state;
        if(serverTimeList && serverTimeList.serverTimeList && dateObject === null){
            let strDatetime = serverTimeList.serverTimeList.server_datetime;
            let timeZone =  getUserTimeZone(this.props.location);
            let convertedDate = converDateToLocal(strDatetime,timeZone.utc_offset,'dateObj','-'); 
            this.setState({dateObject:convertedDate});
        }
        if (notificationReadActivity && (notificationReadStatus !== prevProps.notificationReadStatus || notificationReadActivity !== prevProps.notificationReadActivity)) { 
            var arrResp = (notificationReadActivity) ? notificationReadActivity.split('~~') : []; 
            var actString = arrResp[0];  
            if(notificationReadStatus===200 && actString===types.NOTIFICATION_READ_SUCCESS) { 
                this.props.history.push(this.state.activeRedirectURL); // REDIRECT TO THE URL 
                if(window.location.pathname === this.state.activeRedirectURL){
                    this.refreshPage();
                }
            }
            else if(notificationReadStatus!==200 || notificationReadActivity===types.NOTIFICATION_READ_ERROR){  
                this.setState({ activeUserNotifId:0, activeRedirectURL:'', toastFlag:true, toastSuccess:false, toastMessage:MSG_NOTIFICATION_READ_STATUS_ERROR}); 
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 5000); 

            }
        }

        if (notificationsFetchDropDownActivity && (notificationsFetchDropDownStatus !== prevProps.notificationsFetchDropDownStatus || notificationsFetchDropDownActivity !== prevProps.notificationsFetchDropDownActivity)) { 
            let arrResp = (notificationsFetchDropDownActivity) ? notificationsFetchDropDownActivity.split('~~') : []; 
            let actString = arrResp[0]; 
            let results = []; 
            let errMsg = ''; 
            let newCount = 0; 
            let unreadCount = 0; 
            if(notificationsFetchDropDownStatus===200 && actString===types.NOTIFICATIONS_FETCH_DROPDOWN_SUCCESS) { 
                if(notificationsFetchDropDownData.results && notificationsFetchDropDownData.results.unread_count) unreadCount = notificationsFetchDropDownData.results.unread_count; 

                if((notificationsFetchDropDownData) && notificationsFetchDropDownData.results && notificationsFetchDropDownData.results.data) {
                    results = notificationsFetchDropDownData.results.data;
                }
                if(results.length===0) errMsg = MSG_NOT_FOUND; 

                let userGroupData = userGroupUrlCheck(this.props.location);
                let userGroup  = '';
                if(userGroupData!==undefined){
                    userGroup  = userGroupData.user_group;
                    userGroupData.notification_count = 0; 
                    if(userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP){
                        setStorage('super', JSON.stringify(userGroupData));
                    }else if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
                        setStorage('affiliate', JSON.stringify(userGroupData));
                    }else if(userGroup===staticConfigs.LOGIN_CLIENT_GROUP){
                        setStorage('client', JSON.stringify(userGroupData));
                    }
                }
                this.setState({ arrNotificationResults:results, notificationCount:0, newNotificationsCount:newCount, commonErrorMsg:errMsg, unreadCount:unreadCount }); 
            }
            else if(notificationsFetchDropDownStatus!==200 || actString===types.NOTIFICATIONS_FETCH_DROPDOWN_ERROR){
                try {  
                    this.setState({ toastFlag:true, toastSuccess:false, toastMessage:MSG_SERVER_DATA_FETCH_ERROR, commonErrorMsg:MSG_NOT_FOUND,arrNotificationResults:results, newNotificationsCount:newCount, unreadCount:unreadCount }); 
                    setTimeout(()=> {
                        this.onCloseToast(); 
                    }, 4000); 
                } catch(error) { 
                }
            } 
        }
    }

    render(){

        const { location } = this.props;
        const { toastMessage,toastFlag,toastSuccess,rand } = this.state; 
        //let newNotifyCount = this.state.newNotificationsCount; 
        let unreadCount = this.state.unreadCount; 
        let results = this.state.arrNotificationResults; 

        let login_as_sa_user = 0;
        // let isSettingAllowed = checkPermissions('settings','view');

        let userGroupData = userGroupUrlCheck(location);
        // console.log(userGroupData); 
        let userGroup = '';
        let uName = '';
        let profileName = '';
        let companyName = '';
        let profileRoute = '';
        let notificationsRoute = '';
        let notificationCount = this.state.notificationCount; 
        let avatar_name = '';
        let companyImg = '';
        let profileImg = '';
        let profileImgTag = '';
        let companyImgTag = '';
        let imgColor = '';
        let activeUserId = 0; 
        let activeUserProfileId  = 0; 
        if(userGroupData!==undefined){
            activeUserId = userGroupData.user_id; 
            activeUserProfileId = userGroupData.associate_id; 
            userGroup = userGroupData.user_group;
            uName = userGroupData.username;
            profileName = userGroupData.profilename.trim();
            // notificationCount = userGroupData.notification_count; 
            profileImg = userGroupData.profile_img;
            avatar_name = userGroupData.avatar_name;
            companyImg = userGroupData.company_image;
            companyName = userGroupData.company_name;
            imgColor = userGroupData.img_color;
            login_as_sa_user = userGroupData.login_as_sa_user; 
            if(!profileImg) {
                profileImgTag = <span id="userProfileImg" className="img-avatar" style={{background:imgColor}}>{avatar_name}</span>
            }else{
                profileImgTag = <span className="user-pic d-none-small right-img-align">
                    <img src={profileImg} alt="Profile image" />
                    </span>
            }if(!companyImg){
                let company_logo_title = '';
                if(companyName)
                company_logo_title = companyName.charAt(0).toUpperCase()
                companyImgTag = <span className="img-avatar" style={{background:'#08E4D0',marginRight:'20px',paddingTop: '2px'}}>{company_logo_title}</span>
            }else{
                companyImgTag = <span className="user-pic d-none-small left-img-align">
                    <img src={companyImg} alt="Company logo" />
                    </span>
            }
            
        }
        if(userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP){
            profileRoute = staticConfigs.ROUTE_PROFILE;
            notificationsRoute = staticConfigs.ROUTE_NOTIFICATIONS;
        }else if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
            profileRoute = staticConfigs.ROUTE_AFFILIATE_PROFILE_MANAGE;
            notificationsRoute = staticConfigs.ROUTE_AFFILIATE_NOTIFICATIONS;
        }else if(userGroup===staticConfigs.LOGIN_CLIENT_GROUP){
            profileRoute = staticConfigs.ROUTE_CLIENT_PROFILE_MANAGE;
            notificationsRoute = staticConfigs.ROUTE_CLIENT_NOTIFICATIONS;
        }

        let isCompanyProfileAllowed = userGroup===staticConfigs.LOGIN_CLIENT_GROUP && checkPermissions('companyprofile','view');
      
        if (location.pathname === '/' || location.pathname === staticConfigs.LOGIN_ROUTE_SUPER_ADMIN || location.pathname === staticConfigs.LOGIN_ROUTE_AFFILIATE || location.pathname === staticConfigs.LOGIN_ROUTE_CLIENT) return null;
        
        let notifyProfileImage = ''; 

        let routesObject = []; 
        if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP) {
            routesObject = notifications.notifiRoutesAffiliate; 
        }
        else if(userGroup===staticConfigs.LOGIN_CLIENT_GROUP) {
            routesObject = notifications.notifiRoutesClient; 
        }

        // let subTitle = ''; 
        // if(location.pathname.includes('schedule-view')) {
        //     subTitle = this.getSubTitle('schedule-view');
        //     this.setState({pageSubTitle:subTitle}); 
        // }
        // else if(location.pathname.includes('skill-rate-cards')) {
        //     subTitle = this.getSubTitle('rate-cards');
        //     this.setState({pageSubTitle:subTitle}); 
        // }

        return(         
            <header>
                <Heartbeat heartbeatFunction={this.setNofificationCount} heartbeatInterval={3000} />
                <div className="container">
                    <div className="row">
                        <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                        <div className="col-lg-7 col-md-7 col-4 col-sm-8 menuButton">
                            <button id="toggle-button" onClick={this.onShowLeftSidebar}><img src={require('../../../'+URL_IMG+'burgar.png')} alt="Menu" /> </button>            
                                <h1 className="d-none-mobile">
                                    {this.getTitle()} 
                                    {/* {subTitle.length > 1 && <span className="padding-left-5 padding-top-5"> {subTitle}</span>} */}
                                    {this.state.pageSubTitle && this.state.pageSubTitle.length > 1 && <span className="padding-left-5 padding-top-5"> {this.state.pageSubTitle}</span>} 
                                </h1>
                            <div className="row">
                                <span className="time-span">{this.state.datetime} {this.state.datetime ? this.state.timeOffset : ''}</span>
                            </div>
                        </div>
                    
                        <div className="col-lg-5 col-md-5 col-sm-4 col-8 userinfo-right">
                            <div className="user-details">
                                
                                {/* <Link to={notificationsRoute} className="user-alert"><img src={require('../../../'+URL_IMG+'icons_bell.png')}  alt="Alerts" />{notificationCount > 0 && <span>{notificationCount}</span>}</Link> */}
                            
                                <div className="dropdown user-details-dropdown" id="dropdown-test" ref={this.wrapperRef}>

                                    <div className={Number(notificationCount) > 99 ? "user-alert-3digits" : 'user-alert'} onClick={this.showNotificationsDropDown} id="dropdownMenuButton-test" aria-haspopup="true" data-toggle="dropdown-test"><img src={require('../../../'+URL_IMG+'icons_bell.png')} alt="Alerts" id="img_bell" />{notificationCount > 0 && <span>{notificationCount}</span>}
                                    </div>
                                    
                                    <div className="dropdown-menu dropdown-menu-right notify-box" id={'dropdown-menu-test'} style={{width: "400px", zIndex:99999}} aria-labelledby={'dropdownMenuButton-test'}>                                   
                                            
                                        <div className="box">

                                            <div className="box-head border-bottom p-3">
                                                {results.length > 0 && <div onClick={this.goToNotifications} className="float-right border-bottom-0 p-0 spanPointer" ><u>{labelConfigs.LBL_SEE_ALL}</u></div>}
                                                <h6>{labelConfigs.LBL_NOTIFICATIONS} {unreadCount > 0 && <span className="badge badge-secondary ml-2">{unreadCount} {labelConfigs.LBL_UNREAD}</span>}</h6>
                                            </div>

                                            <div className="box-content">
                                                {results.length===0 && 
                                                    <div className="text-center padding-top-10"><small className="text-muted">{this.state.commonErrorMsg}</small></div>
                                                }

                                            {results.length > 0 && results.map((item, index) => {
                                                let actVar = String(item.action); 
                                                let redirectURL = routesObject[actVar] && routesObject[actVar].length > 0 ? routesObject[actVar] : ''; // notifications[item.action];
                                                let refId = (item[notifications.notifiActionDictionary[item.action]]) ? item[notifications.notifiActionDictionary[item.action]] : '';
                                                let menuActiveItem = (notifications.notifiLeftMenuActiveDictionary[item.action]) ? notifications.notifiLeftMenuActiveDictionary[item.action] : '';
                                                
                                                notifyProfileImage = <img className="img-fluid img-prof-small-notification" src={require('../../../'+URL_IMG+'profile-image.png')} alt={item.name} title={item.name} />; 
                                                if ((item.profile_picture) && item.profile_picture.trim().length > 0){
                                                    notifyProfileImage = <img className="img-fluid  img-prof-small-notification" src={item.profile_picture} alt={item.name} title={item.name} />;
                                                }
                                                else if(((!item.profile_picture) || item.profile_picture.trim().length===0) && item.avatar_name && item.avatar_name.trim().length > 0) {
                                                    notifyProfileImage = <span title={item.name} className="img-fluid img-prof-small-notification img-avatar" style={{background:item.profile_color}}>{item.avatar_name} </span>; 
                                                }

                                                let notifiAction = ''; 
                                                if(notifications.notifiActionTypes[item.action]) notifiAction = notifications.notifiActionTypes[item.action]; 

                                                if(redirectURL && redirectURL.length > 0) {
                                                    return(
                                                        <div key={index} className="col-12 p-0 text-muted spanPointer" onClick={(e) => this.readAndRedirect(item.user_notif_id,item.is_read,redirectURL+refId,menuActiveItem,refId,notifiAction)} >
                                                            <div className={item.is_read ? "notification-item-link border-bottom px-2 py-1 d-flex flex-row" : "notification-item-link border-bottom px-2 py-1 d-flex flex-row bg-notify"}>
                                                                <div className="avatar-block">{notifyProfileImage}</div>
                                                                <div className="col-md-10 pl-0 pr-0">
                                                                    <div className="mb-0">
                                                                        <div className="text-muted text-12">{ReactHtmlParser(item.notification_string) }</div>
                                                                        <div className="text-muted  text-11"><Moment fromNow>{item.created_on}</Moment></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> 
                                                        
                                                    )
                                                }else {
                                                    return(
                                                        <div key={index} className="col-12 p-0 text-muted" >
                                                            <div className={item.is_read ? "notification-item-link border-bottom px-2 py-2 d-flex flex-row" : "notification-item-link border-bottom px-2 py-2 d-flex flex-row bg-notify"}>
                                                                <div className="avatar-block">{notifyProfileImage}</div>
                                                                <div className="col-md-10 pl-0 pr-0">
                                                                    <p className="mb-0">
                                                                        <small className="text-muted">{ReactHtmlParser(item.notification_string) }</small>
                                                                    </p>
                                                                    <h6 className="text-muted"><small><Moment fromNow>{item.created_on}</Moment></small></h6>
                                                                </div>
                                                            </div>                                                             
                                                        </div> 
                                                    )
                                                }

                                                // return(
                                                //     <div key={index} className="col-12 p-0">
                                                //         <div onClick={this.goToNotifications} className={item.is_read ? "spanPointer notification-item-link border-bottom px-3 py-2 d-flex flex-row" : "spanPointer notification-item-link border-bottom px-3 py-2 d-flex flex-row bg-notify"}>
                                                //             {notifyProfileImage}
                                                //             <div className=" pl-4">
                                                //                 <p className="mb-2">
                                                //                     <small className="text-muted">{ReactHtmlParser(item.notification_string) }</small>
                                                //                 </p>
                                                //                 <h6 className="text-muted"><small><Moment fromNow>{item.created_on}</Moment></small></h6>
                                                //             </div>
                                                //         </div>                                                             
                                                //     </div> 
                                                // )
                                            })}                          
                                            </div>
                                            <div className="p-0 d-block">
                                                {results.length > 0 && <Link to="#" className="text-center border-bottom-0">
                                                    <div onClick={this.goToNotifications}><u>{labelConfigs.LBL_SEE_ALL} {labelConfigs.LBL_NOTIFICATIONS}</u></div></Link>}
                                            </div>
                                        </div>        
                                    </div>
                                </div>

                                

                                <div className="dropdown" id="profile-dropdown">
                                    <button className="btn dropdown-toggle" type="button" data-toggle="dropdown" onBlur={this.remShowProfile} onClick={this.onShowProfile}>             
                                    {companyImgTag}
                                    <span className="company-name d-none-small">{(profileName.trim().length > 1) ? profileName: uName}</span>
                                    {profileImgTag} 
                                    {/* 
                                        CLICK ON OUTSIDE THE PROFILE MENU DOES NOT HIDE THE PROFILE MENU IN SAFARI BROWSER 
                                        SO ADDED AN IMAGE AS INPUT TYPE AND FOCUSED ON IT MANUALLY - AND IN 'onBlur' 'remShowProfile' FUNCTION CALLED - ADDED ON 24 AUG2021  
                                    */}
                                    {isSafariBrowser && <input type="image" id="img-profile-logo" src={require('../../../'+URL_IMG+'action.png')} alt="" onBlur={this.remShowProfile} style={{width:'0px'}} /> }  
                                    </button>
                                    <ul className="dropdown-menu" id="dropdown-menu">
                                        <li><span className="user-pic d-block-small">
                                            <img src={require('../../../'+URL_IMG+'logo.png')} alt="Company name" />     
                                            </span>  
                                            <span className="company-name d-block-small">{uName}</span></li>

                                        {/* {Number(login_as_sa_user)===0 && <li><Link onMouseDown={this.showAssocUser} to="#">{labelConfigs.LBL_MY_PROFILE}</Link></li>} */}
                                        
                                        {Number(login_as_sa_user)===0 && <li><Link onMouseDown={this.showAssocUser} to="#" >{labelConfigs.LBL_MY_PROFILE} </Link></li>}
                                        {isCompanyProfileAllowed &&
                                        <li><Link onMouseDown={this.onTriggerClick} to={profileRoute}>{labelConfigs.LBL_COMPANY_PROFILE}</Link></li>
                                        }
                                        {Number(login_as_sa_user)===0 && <li><Link onMouseDown={e => this.changePwd(e,userGroup)} to="#" >{labelConfigs.LBL_CHANGE_PASSWORD} </Link></li>}

                                        <li><Link  to="#" 
                                        onMouseDown={this.onLogout} >{labelConfigs.LBL_LOGOUT}</Link></li>
                                    </ul>
                                </div>

                                {/* <div className={(isSettingAllowed && userGroup!==staticConfigs.LOGIN_SUPER_ADMIN_GROUP)?"right-menu":"hide"}>
                                    {userGroup!==staticConfigs.LOGIN_CLIENT_GROUP && <Link to="#" className="right-menu-icon">                                    
                                        <img src={require('../../../'+URL_IMG+'action.png')} alt="settings" onClick={this.onShowSettings}/>
                                    </Link>}
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
                
                <ModalWindow ref={this.modal} header={labelConfigs.LBL_MY_PROFILE} type="formSubmit" resetModalForm={this.onModalFormReset} showDeleteLinkLeft='' > 
                  <AssociateAddEditComponent location={this.state.location} activeUserId={activeUserId} activeUserProfileId={activeUserProfileId} calledFrom='profile' closeMyProfile={this.closeMyProfile} fromEdit={false}/>
               </ModalWindow>  

            </header>
        )
    }
    
}

const mapStateToProps = (state) => {
    return {
        logout : state.logout.data,
        activity: state.logout.activity,
        status: state.logout.status,
        notificationsFetchDropDownData: state.fcmNotifiToken.notificationsFetchDropDownData, 
        notificationsFetchDropDownStatus: state.fcmNotifiToken.notificationsFetchDropDownStatus,  
        notificationsFetchDropDownActivity: state.fcmNotifiToken.notificationsFetchDropDownActivity, 
        notificationsFetchDropDownErrorData: state.fcmNotifiToken.notificationsFetchDropDownErrorData, 
        scheduleViewType: state.event.scheduleViewType,
        notificationReadStatus:state.fcmNotifiToken.notificationReadStatus,
        notificationReadActivity:state.fcmNotifiToken.notificationReadActivity,
        notificationReadErrorData:state.fcmNotifiToken.notificationReadErrorData,
        serverTimeList:state.serverTimeList,
        expiringCertificateTitle:state.certificates.expiringCertificateTitle,
        shiftTitle:state.commons.shiftTitle,
        feedbackTitle:state.commons.feedbackTitle,
        timesheetDateTitle:state.commons.timesheetDateTitle,
        timesheetDateTitle:state.commons.timesheetDateTitle,
        crewListTitle:state.commons.crewListTitle,
        scheduleHeadingSubTitle: state.event.scheduleHeadingSubTitle,
        rateCardPageSubTitle:state.masterRateCard.rateCardPageSubTitle,
    }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        logoutUserAction:logoutUserAction,
        notificationsFetchDropDownAction:notificationsFetchDropDownAction,
        notificationReadAction:notificationReadAction,
        menuActiveAction:menuActiveAction, 
        assocUserActiveAction:assocUserActiveAction,
        clearAction:clearAction,        
        serverTimeAction:serverTimeAction,
        eventPopupIdSetAction:eventPopupIdSetAction, 
        shiftPopupIdSetAction:shiftPopupIdSetAction, 
    },dispatch);
}
// export default NetworkDetector(connect(mapStateToProps,mapDispatchToProps)(withRouter(HeaderComponent)));
export default connect(mapStateToProps,mapDispatchToProps)(withRouter(HeaderComponent));